import React, { useEffect, useLayoutEffect, useState, useContext } from 'react';
import { MdModeEdit, MdDelete } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { color } from 'styles/pallete';
import Load from 'components/Load';
import FormProvider from 'components/FormProvider';
import { CredentialChild, CredentialFather } from 'types/ProvidersProps';
import { UseTranslationProps } from 'types/UseTranslationProps';
import { getProvidersSettings, deleteProvider } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import ConfirmScreen from 'components/ConfirmScreen';
import { updateCredentialRecursively } from './function';

interface ProvidersSettingsProps {
	isVisiable: boolean;
	listProviders: CredentialFather[];
	setListProviders: React.Dispatch<React.SetStateAction<CredentialFather[]>>;
}

export default function ProvidersSettings({
	isVisiable,
	listProviders,
	setListProviders
}: ProvidersSettingsProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const isReq = false; // por enquanto não é necessário por que ao abrir os settings todas as requisição são desparadas e o usuário precisa aguardar finalziar e quando cai aqui os itens já foram carregados

	const [isOpenForm, setIsOpenForm] = useState(false);
	const [providerToEdit, setProviderToEdit] = useState<CredentialChild | null>(
		null
	);
	const [isConfirmDelete, setIsConfirmDelete] = useState(false);
	const [itemToDelete, setItemToDelete] = useState<null | CredentialChild>(
		null
	);

	async function getProviders() {
		const { data, isSuccess } = await getProvidersSettings(
			handleNotify,
			setIsOpenLoad,
			setMessage
		);

		if (isSuccess && data.length > 0) {
			setListProviders(data);
		}
	}

	async function handleDeleteItem() {
		if (itemToDelete === null) return;
		setIsOpenLoad(true);

		const { isSuccess, data } = await deleteProvider(itemToDelete);

		if (isSuccess && data !== null) {
			setListProviders(updateCredentialRecursively(listProviders, data));
			handleNotify('Credencial desabilitada com sucesso', 'success');
		} else {
			handleNotify(t('Erro ao desabilitar a credêncial'), 'error');
		}

		setIsOpenLoad(false);
	}

	//volta o valor padrão para itemToEdit quando o form é fechado
	useLayoutEffect(() => {
		if (!isOpenForm && providerToEdit !== null) {
			setProviderToEdit(null);
		}
	}, [isOpenForm]);

	useEffect(() => {
		(async () => {
			await getProviders();
		})();
	}, []);

	return (
		<S.container $isShow={isVisiable}>
			{isReq ? (
				<S.centralize>
					<Load showText text={t('settings.providersSettings.loadProviders')} />
				</S.centralize>
			) : (
				<>
					{listProviders.length === 0 ? (
						<S.centralize>
							<S.noProviders>
								{t('settings.providersSettings.noProviders')}
							</S.noProviders>
						</S.centralize>
					) : (
						<S.lists>
							{listProviders.map((itemFather) => (
								<S.list key={itemFather.id}>
									<S.title>{itemFather.name} </S.title>
									<S.list>
										{itemFather?.credentials?.length === 0 ? (
											<S.noProviders>{`${t('settings.providersSettings.noProvidersTo')} ${itemFather.name}`}</S.noProviders>
										) : (
											itemFather?.credentials?.map((itemChild) => (
												<S.item key={itemChild.id}>
													<S.infos>
														<p>
															<b>Status:</b>{' '}
															{itemChild.credential === null ||
															itemChild.credential === ''
																? 'Inativo'
																: 'Ativo'}
														</p>
														<p>
															<b>Slug: </b> {itemChild.slug}
														</p>
													</S.infos>

													<S.btns>
														<MdModeEdit
															style={{
																fontSize: '2.5rem',
																color: color.interface.lightGray,
																cursor: 'pointer'
															}}
															onClick={() => {
																setIsOpenForm(true);
																setProviderToEdit(itemChild);
															}}
														/>

														<MdDelete
															style={{
																fontSize: '2.5rem',
																color: color.interface.lightGray,
																cursor:
																	itemChild.credential === null ||
																	itemChild.credential === ''
																		? 'not-allowed'
																		: 'pointer',
																opacity:
																	itemChild.credential === null ||
																	itemChild.credential === ''
																		? 0.2
																		: 1
															}}
															onClick={() => {
																if (
																	itemChild.credential !== null &&
																	itemChild.credential !== ''
																) {
																	setItemToDelete(itemChild);
																	setIsConfirmDelete(true);
																}
															}}
														/>
													</S.btns>
												</S.item>
											))
										)}
									</S.list>
								</S.list>
							))}
						</S.lists>
					)}
				</>
			)}

			{isOpenForm && (
				<FormProvider
					setListProviders={setListProviders}
					listProviders={listProviders}
					isOpen={isOpenForm}
					setIsOpen={setIsOpenForm}
					itemProviderToEdit={providerToEdit}
					setItemProviderToEdit={setProviderToEdit}
				/>
			)}

			<ConfirmScreen
				setIsOpen={setIsConfirmDelete}
				isOpen={isConfirmDelete}
				title={t('dynamicShowCase.listDynamicShowCase.confirmation')}
				message={
					<p>
						{t('Tem certeza que deseja desabilitar o provider')}{' '}
						<b style={{ fontFamily: 'nunito-bold' }}>{itemToDelete?.name}</b>?
					</p>
				}
				buttonClose={false}
				functionToExecOnConfirm={handleDeleteItem}
			/>
		</S.container>
	);
}
